module.exports = __webpack_public_path__ + "assets/img/panorama-big.1a9c348c.png";